module.exports = __webpack_public_path__ + "img/coin500.5e793bde.png";